import React, { Component } from 'react';

class Krb5Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      prinicpal: "",
      realm: "HWSS.HPC.MIL",
      password: "",
      token: ""
    };
  }

  render() {
    return (
      <div>
        <form onSubmit={ this.saveAndContinue }>
        <div>
          <div className="usa-input-grid usa-input-grid-medium">
            <label>Kerberos Principal</label> 
            <input name="principal" type="text" onChange={this.handleInputChange} />
          </div>
          <div className="usa-input-grid usa-input-grid-small">
            <label>Kerberos Realm</label> 
            <select name="realm" onChange={this.handleInputChange}>
	      {window.OIDC_IDP_KRB5_REALMS.map((realm) => <option key={"realm-"+realm} value={realm}>@{realm}</option>)}
            </select>
          </div>
        </div>
        <label>Password</label>
        <input name="password" type="password" onChange={this.handleInputChange} />
        <label>Yubikey Token</label>
        <input name="token" type="password" onChange={this.handleInputChange} />
        <button type="submit">Submit</button>
        <button className="usa-button-secondary" onClick={this.props.onBackToOptions}>Back to Options</button>
        </form>
      </div>
    );
  }

  handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  saveAndContinue = (e) => {
    e.preventDefault();

    var data = {
      principal: this.state.principal,
      realm: this.state.realm,
      password: this.state.password,
      token: this.state.token
    };

    this.props.onLogin(data);
  }
}

export default Krb5Form;



// WEBPACK FOOTER //
// ./src/Krb5Form.jsx